"use client";
import Image, { ImageProps } from "next/image";
import { useState } from "react";

interface ImageWithSkeletonProps extends Omit<ImageProps, "src"> {
    src?: string;
    isLoadingUrl?: boolean;
    containerClassName?: string;
}

export default function ImageWithSkeleton({
    src,
    alt,
    isLoadingUrl = false,
    className = "",
    containerClassName = "",
    ...props
}: ImageWithSkeletonProps) {
    const [isImageLoaded, setIsImageLoaded] = useState(false);

    const showSkeleton = isLoadingUrl || !src || !isImageLoaded;

    return (
        <div className={`relative overflow-hidden ${containerClassName}`}>
            {showSkeleton && (
                <div className="absolute inset-0 z-10 flex items-center justify-center overflow-hidden rounded-xl border border-border-color bg-card-bg">
                    {/* Website Theme Card & Border Color Shimmer Base */}
                    <div className="absolute inset-0 animate-pulse bg-gradient-to-r from-card-bg via-border-color to-card-bg" />
                    {/* Website Theme Primary Color Shimmer Highlight */}
                    <div className="absolute inset-0 animate-pulse bg-gradient-to-r from-transparent via-primary/20 to-transparent" />
                    {/* Theme Primary Spinner */}
                    <div className="relative h-6 w-6 animate-spin rounded-full border-2 border-primary border-t-transparent opacity-80" />
                </div>
            )}
            {src && (
                <Image
                    src={src}
                    alt={alt}
                    onLoad={() => setIsImageLoaded(true)}
                    fetchPriority={props.priority ? "high" : undefined}
                    className={`transition-opacity duration-300 ease-in-out ${
                        isImageLoaded ? "opacity-100" : "opacity-0"
                    } ${className}`}
                    {...props}
                />
            )}
        </div>
    );
}
